export interface ProductEvent {
  _id: string;
  event: string;
  funnel?: string;
  step?: string;
  user?: { _id: string; firstName?: string; lastName?: string; email?: string } | null;
  sessionId?: string;
  role?: string;
  path?: string;
  metadata?: Record<string, unknown>;
  createdAt: string;
}

export interface ProductEventFilters {
  event?: string;
  funnel?: string;
  userId?: string;
  from?: string;
  to?: string;
}

export interface FunnelStepStat {
  event: string;
  count: number;
  uniqueUsers: number;
  conversionFromStart: number;
}

export interface FunnelStats {
  funnel: string;
  steps: FunnelStepStat[];
}

export interface TopPathStat {
  path: string;
  count: number;
  uniqueUsers: number;
}

/** Kept in sync with mynda-api's productEvent.taxonomy.ts by convention. */
export const KNOWN_FUNNELS = ["navigation", "signup", "kyc", "job_apply", "hire"] as const;
